import { inject } from '@angular/core';
import { IParsedOrders } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';
import { IGetGateway } from '../gateways';

export class UserOrdersGateway implements IGetGateway<
  string,
  IApiResponse<IParsedOrders>
> {
  private readonly restCallBuilder: RestCallBuilder<IParsedOrders> =
    new RestCallBuilder<IParsedOrders>({
      activeOrders: [],
      archivedOrders: [],
    });
  private readonly configService: AppConfigService = inject(AppConfigService);

  get(_userId: string): Observable<IApiResponse<IParsedOrders>> {
    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.directTicketUrl + '/orders/me'
      )
      .handleMessages()
      .build();
  }
}
